<ng-template #actualControl>
    <ng-content select="[actualControl]"></ng-content>
</ng-template>
<ng-template #mobileControl let-offcanvas>
    <div class="c-po-header-container" *ngIf="mobileModalTitle">
        <div class="c-po-header-title-container">
            <h4 class="offcanvas-title c-po-header-title">
                {{ mobileModalTitle }}
            </h4>
        </div>
        <button
            type="button"
            aria-label="Close"
            class="c-po-header-close-button"
            (click)="close()"
        >
            <ion-icon name="close-circle-outline"></ion-icon>
        </button>
    </div>
    <div class="c-po-header-placeholder" *ngIf="!mobileModalTitle"></div>
    <div class="c-po-modal-content">
        <ng-container *ngTemplateOutlet="actualControl"></ng-container>
    </div>
    <div class="c-po-modal-footer">
        <div class="c-po-modal-footer-button">
            <a
                *ngIf="mobileSecondaryButtonVisible"
                (click)="onModalSecondaryButtonClick()"
                >{{ mobileSecondaryButtonText }}</a
            >
            <button
                mdMainButton="light"
                [disabled]="mobileContinueButtonDisabled"
                (click)="onModalContinueClick()"
            >
                {{ mobileContinueButtonText }}
            </button>
        </div>
    </div>
</ng-template>
<div
    class="c-po-dark-bkg"
    [ngClass]="{ open: isOpen }"
    *ngIf="darkBackgroundOnOpen"
></div>
<div
    [ngbPopover]="actualControl"
    popoverClass="c-po-popover-class"
    [ngClass]="{
        'c-po-open': isOpen
    }"
    [placement]="'bottom-left'"
    [autoClose]="'outside'"
    triggers="manual"
    #d="ngbPopover"
    (shown)="onPopoverShown()"
    (hidden)="onPopoverHidden()"
>
    <ng-content select="[targetControl]"></ng-content>
</div>
